// src/services/weatherApi.jsx
import { coreGet } from "@/services/coreApi"

// { activeRun, activatedAt, previousRun } — the run core computes routes with.
export async function getWeatherStatus(accessContext, setAccessContext) {
  return coreGet("/weather/status", accessContext, setAccessContext, ".core /weather/status error=")
}
